//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {apiUrl, apiParams} from '@/const/const'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
    name: 'Quote',
    components: {
        MyBtnReturn
    },
    data() {
        return {
            sPlaceOps: [], // 起始地列表
            sPortOps: [], // 起始港列表
            ePortOps: [], // 目的港列表
            ePlaceOps: [], // 目的地列表
            contTypeOps: [], // 柜型列表
            // options: [
            //   {
            //     key: 'gd',
            //     value: '广东'
            //   },
            //   {
            //     key: 'gx',
            //     value: '广西'
            //   }
            // ], // 虚假数据，后续注释
            splace: null,
            sport: null,
            eport: null,
            eplace: null,
            cont: null,
        }
    },
    created() {
        document.title = '报价查询';
        this.getInitialSelectData()
    },
    methods: {
        getInitialSelectData() {
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
            };
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.requestApi({
                url: apiUrl.quoteSearchCondition,
                data: data
            }, (resultData) => {
                this.$vux.loading.hide();
                let dataObj = resultData.data;
                this.sPlaceOps = dataObj.splaces || [];
                this.sPortOps = dataObj.sports || [];
                this.ePortOps = dataObj.eports || [];
                this.ePlaceOps = dataObj.eplaces || [];
                this.contTypeOps = dataObj.conts || []
            }, (error) => {
                this.$vux.loading.hide();
                if (error) {
                    // todo:如果请求失败，2秒后可重新获取，或者提示用户刷新页面？
                    setTimeout(() => {
                        this.getInitialSelectData()
                    }, 2000);
                    console.error(error);
                }
            })
        },
        goResultPage() {
            let route = {
                name: 'QuoteResult',
                query: {
                    splace: this.splace || '', // 一开始没选择是null，遇到此情况可以换成空字符串；当然也可以不传递，这个不是必传的参数
                    sport: this.sport || '',
                    eport: this.eport || '',
                    eplace: this.eplace || '',
                    cont: this.cont || '',
                }
            };
            this.$router.push(route)
        },

        sPlaceChange() {

        },
        sPortChange() {

        },
        ePortChange() {

        },
        ePlaceChange() {

        },
        contChange() {

        },
    }
}



// WEBPACK FOOTER //
// ./src/components/yewu/quote/quote.vue